<template>
<div class="container-fluid">
  <div class="row marketing">
    <div class="col-lg-3">
      <h4 class="form-head">
        New Credential
      </h4>
      <form action="" name="cform1">
        <div class="form-group">
          <label for="gst">GST Number</label>
          <input type="text" class="form-control"
                 id="gst" aria-describedby="emailHelp"
                 v-model="c.gstNumber"
                 required
                 placeholder="Enter your GST Number">

        </div>
        <div class="form-group">
          <label for="un">EWaybill User Name</label>
          <input type="text" class="form-control"
                 id="un" aria-describedby="emailHelp"
                 v-model="c.userName"
                 required
                 placeholder="Enter your UserName">

        </div>
        <div class="form-group">
          <label for="pwd">EWaybill Password</label>
          <input type="password" class="form-control"
                 id="pwd" aria-describedby="emailHelp"
                 v-model="c.password"
                 required
                 placeholder="Enter your Password">

        </div>
        <div class="form-group" v-if="podTenant">
          <label for="loca">Locations</label>
          <select class="form-control" multiple id="loca" v-model="c.locations">
            <option v-for="f of locations" :key="f.id" :value="f.id">{{f.name}}</option>
          </select>
        </div>
        <div class="form-group">
          <label for="loca">Alert EMails (One Per Line)</label>
          <textarea class="form-control" multiple id="alertEmails" v-model="c.alertEmails"></textarea>
        </div>

        <button type="button" v-on:click="saveCred()" class="btn btn-primary">
          <i class="fa fa-save"></i> Save
        </button>

      </form>
    </div>
    <div class="col-lg-9">
      <h4 class="form-head">
        Existing Credentials
      </h4>
      <table class="table">
        <thead class="thead-dark">
        <tr>
          <th>User Name</th>
          <th>GST Number</th>
          <th>State</th>
          <th v-if="podTenant">Locations</th>
          <th>Valid?</th>
          <th>Alert EMails?</th>
          <th>&nbsp;</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="u of creds" :key="u.id">
          <td>{{u.userName}}</td>
          <td>{{u.gstNumber}}</td>
          <td>{{u.state}}</td>
          <td v-if="podTenant">
            <ul class="list-unstyled">
              <li v-for="l in u.locations" :key="l">
                <span v-if="locationMap[l]"><i class="fa fa-warehouse"></i> {{locationMap[l].name}}</span>
              </li>
            </ul>
          </td>
          <td>
            <span v-if="u.valid === true" class="text-success"><i class="fa fa-check"></i> Yes</span>
            <span v-if="u.valid === false" class="text-danger"><i class="fa fa-times"></i> No</span>
          </td>
          <td>
            {{u.alertEMails}}
          </td>
          <td>
            <button class=" btn btn-primary btn-sm" v-on:click="editCred(u)">
              <i class="fa fa-pencil"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>

    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'

let apiUrl = `/app/cred`
let locationUrl = `/app/location`

export default {
  name: 'CredentialPage',
  created: function () {
    this.$store.dispatch('isLoggedIn').then(() => {
      if (!this.$store.state.loggedIn) {
        console.log('Not Logged-in')
        this.$router.push('login')
      }
      this.loadCreds()
    }, _ => {
      console.error('isLoggedIn Failed, lets go to login')
      this.$router.push('login')
    })
  },
  data () {
    return {
      creds: [],
      locations: [],
      c: {
        gstNumber: '',
        userName: '',
        password: '',
        credType: 'EWAYBILL',
        locations: []
      },
      locationMap: {},
      transporterMap: {},
    }
  },
  computed: {
    ewbTenant () {
      return this.$store.state.ewbTenant
    },
    podTenant () {
      return this.$store.state.podTenant
    },
    localAdmin () {
      return this.$store.state.localAdmin
    }
  },
  methods: {
    loadCreds: function () {
      axios.all([axios.get(apiUrl), axios.get(locationUrl)])
        .then(axios.spread((response, locations) => {
          this.creds = response.data
          this.locations = locations.data
          this.locations.forEach(l => {
            this.locationMap[l.id] = l
          })
        }, error => {
          console.error('Error in Loading Creds', error)
        }))
    },
    saveCred: function () {
      axios.post(apiUrl, this.c)
        .then(response => {
          this.loadCreds()
          this.c = {
            gstNumber: '',
            userName: '',
            password: '',
            credType: 'EWAYBILL',
            locations: []
          }
        }, error => {
          console.error('error in saving cred', error)
        })
    },
    editCred: function (cred) {
      this.c = cred
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/CredentialPage.vue